import React from 'react';
import { ShoppingBagIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Jamie Patel',
  title: 'Merchandise Designer',
  specialties: ['Apparel', 'Accessories', 'Branding'],
  rating: 4.7,
  reviewCount: 63,
  imageUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$100-500'
}, {
  id: '2',
  name: 'Quinn Smith',
  title: 'Book Merchandise Specialist',
  specialties: ['Bookmarks', 'Candles', 'Gift Boxes'],
  rating: 4.5,
  reviewCount: 47,
  imageUrl: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: false,
  priceRange: '$150-600'
}];
const MerchCreators = () => <CreativeDirectoryPage title="Merchandise Creators" subtitle="Connect with talented designers who can create unique merchandise for your books and brand" icon={<ShoppingBagIcon className="h-8 w-8" data-id="element-8621" data-mp="y7bvudnkuzbb" />} profileBasePath="/creative/merch-creators" artists={artists} data-id="element-8620" data-mp="2ds5mhgyr653i" />;
export default MerchCreators;